<app-modal-header-common [title]="modalHeader" [dialogRef]="dialogRef">
</app-modal-header-common>

<!-- ==================== TEMPLATE DETAILS ==================== -->
<div class="plan-form" [hidden]="step === 2">
  <form [formGroup]="templateForm">
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" required />
    </mat-form-field>
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Description</mat-label>
      <input matInput formControlName="description" required />
    </mat-form-field>
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Category</mat-label>
      <mat-select formControlName="category" required>
        <mat-option *ngFor="let option of categories" [value]="option.id">
          {{ option.display_name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Applicability</mat-label>
      <input matInput formControlName="applicability" />
    </mat-form-field>
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Scoring Methodology</mat-label>
      <input matInput formControlName="scoring_methodology" />
    </mat-form-field>
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Assessment Scoring Scale</mat-label>
      <input matInput formControlName="assessment_scoring_scale" />
    </mat-form-field>
    <app-tag
      [noIds]="true"
      [tagsIds]="assessmentTags"
      (childTags)="getChildTags($event)"
    ></app-tag>

    <div style="display: flex; justify-content: end" class="mt-3">
      <button mat-button mat-dialog-close color="primary" class="mx-1">
        Close
      </button>
      <button
        mat-raised-button
        color="primary"
        class="templ-btn"
        (click)="goNext()"
      >
        Next
      </button>
    </div>
  </form>
</div>

<!-- ==================== GROUP/QUESTION/CONTEXT TREE ==================== -->
<div class="p-3" [hidden]="step === 1">
  <div class="d-flex" style="gap: 12px; height: 65vh">
    <!-- ==================== LEFT: TREE ==================== -->
    <div
      class="tree-pane"
      style="
        width: 30%;
        min-width: 260px;
        display: flex;
        flex-direction: column;
        border: 1px solid #d9d9d9;
        border-radius: 8px;
        background: #f7f7f7;
        overflow: hidden;
      "
    >
      <div style="flex: 1; overflow-y: auto; padding: 6px">
        <div
          *ngFor="let group of groups; let gi = index"
          class="mb-1"
          style="
            border: 1px solid #dcdcdc;
            border-radius: 6px;
            background: white;
            overflow: hidden;
          "
        >
          <!-- Group row -->
          <div
            class="d-flex align-items-center"
            style="gap: 4px; padding: 4px 6px; background: #eef0f2"
          >
            <mat-icon
              style="
                cursor: pointer;
                font-size: 20px;
                width: 20px;
                height: 20px;
              "
              (click)="toggleGroup(group)"
            >
              {{ group.expanded ? "expand_more" : "chevron_right" }}
            </mat-icon>
            <span
              *ngIf="groupHasError(group)"
              class="error-dot"
              matTooltip="This group has incomplete fields"
            ></span>
            <input
              class="tree-input tree-input-domain"
              [(ngModel)]="group.group"
              name="group{{ gi }}"
              placeholder="Group name"
            />
            <button
              mat-icon-button
              matTooltip="Add question"
              style="width: 26px; height: 26px; line-height: 26px"
              (click)="addQuestion(group, gi)"
            >
              <mat-icon style="font-size: 16px; width: 16px; height: 16px"
                >add</mat-icon
              >
            </button>
            <button
              mat-icon-button
              color="warn"
              matTooltip="Remove group"
              style="width: 26px; height: 26px; line-height: 26px"
              (click)="removeGroup(gi)"
            >
              <mat-icon style="font-size: 16px; width: 16px; height: 16px"
                >delete</mat-icon
              >
            </button>
          </div>

          <div *ngIf="group.expanded" style="padding: 2px 0 2px 14px">
            <div
              *ngFor="let question of group.questions; let qi = index"
              class="requirement-row d-flex align-items-center mt-1 mb-1"
              [class.requirement-row-selected]="isSelected(gi, qi)"
              (click)="selectQuestion(gi, qi)"
              style="
                gap: 4px;
                padding: 4px 6px;
                cursor: pointer;
                border-radius: 4px;
                border-start: 2px solid #e0e0e0;
                margin-left: 6px;
              "
            >
              <span
                *ngIf="questionHasError(question)"
                class="error-dot"
                matTooltip="This question has incomplete fields"
              ></span>
              <mat-icon
                style="font-size: 14px; width: 14px; height: 14px; color: #999"
              >
                description
              </mat-icon>
              <span
                class="requirement-label"
                style="
                  flex: 1;
                  font-size: 12.5px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
              >
                {{ question.question?.trim() || "New question" }}
              </span>
              <span
                class="badge bg-light text-dark"
                style="font-size: 10px"
                matTooltip="Responses"
              >
                {{ question.records[0]?.response_choices?.length || 0 }} resp
              </span>
              <button
                mat-icon-button
                color="warn"
                matTooltip="Remove question"
                style="width: 22px; height: 22px; line-height: 22px"
                [disabled]="group.questions.length === 1"
                (click)="
                  removeQuestion(group, gi, qi); $event.stopPropagation()
                "
              >
                <mat-icon style="font-size: 14px; width: 14px; height: 14px"
                  >delete</mat-icon
                >
              </button>
            </div>
          </div>
        </div>
      </div>

      <div style="padding: 6px; border-top: 1px solid #dcdcdc">
        <button
          mat-stroked-button
          color="accent"
          style="width: 100%"
          (click)="addGroup()"
        >
          <mat-icon>add</mat-icon> Add Group
        </button>
      </div>
    </div>

    <!-- ==================== RIGHT: DETAIL EDITOR ==================== -->
    <div
      class="detail-pane"
      style="
        flex: 1;
        overflow-y: auto;
        border: 1px solid #d9d9d9;
        border-radius: 8px;
        padding: 16px;
      "
    >
      <ng-container *ngIf="selectedRecord; else noSelection">
        <div style="font-size: 12px; color: #888; margin-bottom: 8px">
          {{ selectedGroup?.group || "Untitled group" }}
        </div>

        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Question <span class="required">*</span></mat-label>
          <textarea
            matInput
            [(ngModel)]="selectedQuestion!.question"
            name="questionDetail"
            rows="2"
          ></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Context</mat-label>
          <input
            matInput
            [(ngModel)]="selectedRecord.context"
            name="contextDetail"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Definition of Done</mat-label>
          <textarea
            matInput
            [(ngModel)]="selectedRecord.definition_of_done"
            name="definitionOfDoneDetail"
            rows="3"
          ></textarea>
        </mat-form-field>

        <!-- Required Documents -->
        <div class="mt-3">
          <label style="font-size: 12px; color: #666">Required Documents</label>
          <button
            mat-stroked-button
            color="primary"
            class="ms-2"
            style="font-size: 12px; padding: 0 10px; line-height: 30px"
            (click)="addRequiredDocument(selectedRecord)"
          >
            <mat-icon style="font-size: 16px; vertical-align: middle"
              >add</mat-icon
            >
            Add Required Document
          </button>
          <div
            *ngFor="
              let doc of selectedRecord.required_documents;
              let di = index
            "
            class="d-flex align-items-start"
            style="gap: 6px"
          >
            <mat-form-field appearance="outline" style="flex: 1">
              <mat-label>Document Name</mat-label>
              <input
                matInput
                [(ngModel)]="doc.name"
                name="requiredDocDetail{{ di }}"
              />
            </mat-form-field>
            <button
              mat-icon-button
              color="warn"
              matTooltip="Remove required document"
              style="margin-top: 6px"
              (click)="removeRequiredDocument(selectedRecord, di)"
            >
              <mat-icon style="font-size: 18px">delete</mat-icon>
            </button>
          </div>
        </div>

        <!-- Responses -->
        <div>
          <label style="font-size: 12px; color: #666">Responses</label>
          <div
            *ngFor="
              let choice of selectedRecord.response_choices;
              let ci = index
            "
            class="d-flex align-items-start"
            style="gap: 6px"
          >
            <mat-form-field appearance="outline" style="width: 180px">
              <mat-label>Response <span class="required">*</span></mat-label>
              <input
                matInput
                [(ngModel)]="choice.response"
                name="responseDetail{{ ci }}"
              />
            </mat-form-field>
            <mat-form-field appearance="outline" style="flex: 1">
              <mat-label>Response Description</mat-label>
              <input
                matInput
                [(ngModel)]="choice.response_description"
                name="responseDescDetail{{ ci }}"
              />
            </mat-form-field>
            <button
              mat-icon-button
              color="warn"
              matTooltip="Remove response"
              style="margin-top: 6px"
              [disabled]="selectedRecord.response_choices.length === 1"
              (click)="removeResponseChoice(selectedRecord, ci)"
            >
              <mat-icon style="font-size: 18px">delete</mat-icon>
            </button>
          </div>
          <button
            mat-stroked-button
            color="primary"
            style="font-size: 12px; padding: 0 10px; line-height: 30px"
            (click)="addResponseChoice(selectedRecord)"
          >
            <mat-icon style="font-size: 16px; vertical-align: middle"
              >add</mat-icon
            >
            Add Response
          </button>
        </div>
      </ng-container>

      <ng-template #noSelection>
        <div
          class="d-flex flex-column align-items-center justify-content-center text-muted"
          style="height: 100%"
        >
          <mat-icon
            style="font-size: 40px; width: 40px; height: 40px; opacity: 0.4"
            >rule</mat-icon
          >
          <p class="mt-2">
            Select a context/response block on the left, or add a new one, to
            edit it here.
          </p>
        </div>
      </ng-template>
    </div>
  </div>

  <div class="d-flex justify-content-between mt-3">
    <button *ngIf="isCreateMode" mat-stroked-button (click)="goBack()">
      Back
    </button>
    <div class="d-flex gap-2 ms-auto">
      <button mat-button mat-dialog-close color="primary">Close</button>
      <button
        mat-flat-button
        color="primary"
        [disabled]="saving || !isValid()"
        (click)="save()"
      >
        Save
      </button>
    </div>
  </div>
</div>
